import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditPP = (props) => {
  const [value, setValue] = useState(props.client.praw_pozew);
  const [loading, setLoading] = useState(false);
  const [lawyerOptions, setLawyerOptions] = useState([]);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: props.client.id,
        praw_pozew: value,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addPPClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano informację o prawniku sporządzającym pozew",
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const createYesNoOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ name: "TAK", value: "TAK" });
    statusOptions.push({ name: "NIE", value: "NIE" });
    statusOptions.push({ name: "Brak danych", value: "Brak danych" });

    return statusOptions;
  };

  useEffect(() => {
    setLawyerOptions(createLawyerOptions());
  }, []);

  const createLawyerOptions = (e) => {
    var bankOptions = [];
    bankOptions.push({ label: "brak danych", value: "brak danych" });
    if (+props.client.team === 0) {
      props.lawyersData.map((el) => {
        bankOptions.push({ label: el.name, value: el.name });
      });
    } else {
      props.lawyersData
        .filter((el) => el.team.includes(+props.client.team))
        .map((el) => {
          bankOptions.push({ label: el.name, value: el.name });
        });
    }

    return bankOptions;
  };

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="sepAddC">Informacje do pozwu</div>

          <div className="inputBox">
            <div className="inputCol_3">
              <label>
                Prawnik sporządzający pozew{" "}
                <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={lawyerOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditPP;
